import {DataGridProps} from '@mui/x-data-grid';
import {fromPairs, omit, sumBy} from 'lodash';

type GridCol = DataGridProps['columns'];

export function applyColumnWidths(columns: GridCol, colWidthData: Record<string, number>): GridCol {
  return columns.map((col) => {
    return {
      ...omit(col, 'flex'),
      ...(colWidthData[col.field] ? {width: colWidthData[col.field]} : {}),
    };
  });
}

export function calcColumnWidths(
  columns: GridCol,
  containerWidth: number,
  hasCheckboxes: boolean,
  paddingProp?: number,
): Record<string, number> {
  const padding = paddingProp ?? (hasCheckboxes ? 56 : 6);
  const fixedColumns = columns.filter((col) => col.minWidth != null || col.width != null);
  const autoColumns = columns.filter((col) => col.minWidth == null && col.width == null);
  const fixedTotalWidth = sumBy(fixedColumns, (col) => Math.max(col.minWidth ?? col.width ?? 0, 0));
  const totalContainerWidth = Math.max(containerWidth - padding - fixedTotalWidth, 0);
  const autoWidth = autoColumns.length > 0 ? totalContainerWidth / autoColumns.length : 0;

  return fromPairs(columns.map((col) => [col.field, Math.max(col.minWidth ?? col.width ?? autoWidth, 0)]));
}
